import type { Pot, PotStructure } from '@ppwr/poker-engine'

/**
 * Legacy pot format (without cumulativeLevel)
 * Used for backwards compatibility during migration
 */
type LegacyPot = {
  amount: number
  eligiblePlayerIds: string[]
  contributions: Record<string, number>
}

/**
 * Union type for pots that can come from either new or legacy format
 */
export type PotsInput = PotStructure | { mainPot: LegacyPot; sidePots: LegacyPot[] }

/**
 * Normalize pots from game document to array format
 * Handles both new array format and legacy object format
 */
export function normalizePots(pots: PotsInput | undefined): Pot[] {
  if (!pots) return []
  if (Array.isArray(pots)) return pots
  // Legacy format with mainPot and sidePots - add cumulativeLevel
  const mainPot: Pot = { ...pots.mainPot, cumulativeLevel: 0 }
  const sidePots: Pot[] = pots.sidePots.map((p, idx) => ({
    ...p,
    cumulativeLevel: (idx + 1) * 100 // Placeholder cumulative levels
  }))
  return [mainPot, ...sidePots]
}
